import offlineFairInstance from "./axios-instances/offlineFairInstance";

export function fetchRegisteredEvents(query) {
    const search = query ? new URLSearchParams(query) : null;
    return offlineFairInstance.get(
        search ? `/registrant/events-registered?${search.toString()}` : "/registrant/events-registered"
    );
}

export function fetchReports(query) {
    const search = new URLSearchParams(query);
    return offlineFairInstance.get(`/registrant/report?${search.toString()}`);
}

export function fetchInternalFairReports(query) {
    const search = new URLSearchParams(query);
    return offlineFairInstance.get(`/internal-registrant/report?${search.toString()}`);
}

export function fetchInternalFairReportsV2(query) {
    const search = new URLSearchParams(query);
    return offlineFairInstance.get(`/internal-registrant/report-v2?${search.toString()}`);
}

export function downloadInternalFairReportsV2(query) {
    const search = new URLSearchParams(query);
    return offlineFairInstance.get(`/internal-registrant/report-v2/download?${search.toString()}`, {
        responseType: "blob",
    });
}

export function fetchInternalFairUniversityReportV2(query) {
    const search = new URLSearchParams(query);
    return offlineFairInstance.get(`/internal-registrant/university-report-v2?${search.toString()}`);
}

export function fetchInternalFairStatsV2(query) {
    const search = new URLSearchParams(query);
    return offlineFairInstance.get(`/internal-registrant/stats-v2?${search.toString()}`);
}

export function fetchInternalFairValidation(fairId) {
    return offlineFairInstance.get(`/fairs/internal/${fairId}/exists`);
}

export function updateRegistrant(payload) {
    return offlineFairInstance.put(`/registrant/`, payload);
}

export function downloadReport(query) {
    const search = new URLSearchParams(query);
    return offlineFairInstance.get(`/registrant/report/download?${search.toString()}`, {
        responseType: "blob",
    });
}
